<template>
  <EntryField
    v-model="modelValue"
    data-refid="mappingRuleEntryDate"
    :label
    :json-data
    :disabled
    class="mapping-rules-entry-date"
  >
    <UIInputDate v-if="!isMappedFromJson" v-model="inputValue" :label :size />
  </EntryField>
</template>

<script setup lang="ts">
import { computed, inject, nextTick, watch } from 'vue'

import { InputSize } from '@types'
import { MappingRuleActionField } from '../utils/types'

import { getCurrentDate } from '@/helpers/dates'

import EntryField from './EntryField.vue'
import { UIInputDate } from '@ui/fields'

type Props = {
  label?: string
  jsonData?: Record<string, unknown>
  disabled?: boolean
}

defineProps<Props>()

const modelValue = defineModel<MappingRuleActionField>()

const size = inject<InputSize>('size')

const inputValue = computed({
  get() {
    return modelValue.value?.value
  },
  set(value) {
    modelValue.value = {
      ...modelValue.value,
      value,
    }
  },
})

const isMappedFromJson = computed(() => modelValue.value?.isMappedFromJson)

watch(isMappedFromJson, mapped => {
  if (mapped) return
  nextTick(() => {
    inputValue.value = getCurrentDate({})
  })
})
</script>

<style>
.mapping-rules-entry-date {
  .v-popper {
    @apply flex-auto;
  }
}
</style>
